<script lang="ts">
  	import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher<{stay:void, next:void}>()
</script>

<div class="text-darkFore">Success!</div>
<button class="btn-darkBack float-left" on:click={() => {dispatch('stay')}}>Stay</button>
<button class="btn-darkBackHigh text-orange float-right" on:click={() => {dispatch('next')}}>Next</button>
